import { Sparkles } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-amber-200/10 py-14 px-6 text-center">
    <Sparkles size={18} className="text-amber-300 mx-auto mb-5" />
    <p className="font-script text-3xl text-rose-200/90">Haya Noor Jamal</p>
    <p className="mt-3 text-xs tracking-[0.3em] uppercase text-slate-500">
      With love, from her family · 19 October 2026
    </p>
    <p className="mt-6 text-[0.65rem] text-slate-600 font-light">
      “And they named her under the stars, and the stars smiled back.”
    </p>
  </footer>
);
